export function round(n: number, places: number = 2) {
  return (+(Math.round(Number(n + 'e+' + places)) + 'e-' + places)).toFixed(places)
}

export const format = {
  totalReturn: (totalReturn: number | string) => round(Number(totalReturn) * 100) + '%',
  maxDrawdown: (maxDrawdown: number | string) => round(Number(maxDrawdown) * 100) + '%',
  sharpeRatio: (sharpeRatio: number) => round(sharpeRatio),
  calmarRatio: (calmarRatio: number) => round(calmarRatio),
  CAGR: (CAGR: number) => round(CAGR * 100) + '%',
  cagr: (CAGR: number) => round(CAGR * 100) + '%',
  volatility: (volatility: number) => round(volatility * 100) + '%',
  numberOfTrades: (numberOfTrades: any) => numberOfTrades,
  positiveDays: (positiveDays: any) => positiveDays,
  negativeDays: (negativeDays: any) => negativeDays,
  bestMonth: (bestMonth: number) => round(bestMonth * 100) + '%',
  worstMonth: (worstMonth: number) => round(worstMonth * 100) + '%',
}

export const figureSpace = ' '

export const BACKTEST_MIN_MAX_DATES = Object.freeze({
  min: new Date(1996, 5, 3),
  max: new Date(2023, 0, 31),
})
